import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';

const TextwithImage = ({ data }) => {
  // Check image position
  const isImageLeft = data.imagePosition === "left";

  return (
    <div className="container">
      <div className={` textimagecontainer ${data.classname} ${isImageLeft ? "image-left" : "image-right"}`}
      >
        {isImageLeft ? (
          <>
            {/* Image Left */}
            <div className="imagecontainertext">
              <img src={data.imageSrc} alt={data.imageAlt} />
            </div>
            <div className="textimagedata">
              <h1>{data.heading}</h1>
              <h3>{data.subheading}</h3>
             
              
                    {data.listItems ? (
                    <ul>
                    {data.listItems.map((item, index) => (
                        <li key={index}><FontAwesomeIcon icon={faCheckCircle} style={{ color: "rgb(255 102 204)" }}/>{item}</li>
                    ))}
                    </ul>
                ) : (
                    <p>{data.paragraph}</p>
                )}
                <Link to={data.url}>
              <button>{data.buttonText}</button></Link>
              <div>{data.author}</div>
            </div>
          </>
        ) : (
          <>
            {/* Image Right */}
            <div className="textimagedata">
              <h1>{data.heading}</h1>
              {data.listItems ? (
                    <ul>
                    {data.listItems.map((item, index) => (
                        <li key={index}><FontAwesomeIcon icon={faCheckCircle} style={{ color: data.classname ==="Eorlist"?"rgb(31 234 147)":"rgb(255 102 204)"  }}/>{item}</li>
                    ))}
                    </ul>
                ) : (
                    <p>{data.paragraph}</p>
                )}
                <Link to={data.url}>
              <button>{data.buttonText}</button></Link>
            </div>
            <div className="imagecontainertext">
              <img src={data.imageSrc} alt={data.imageAlt} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TextwithImage;
